module.exports = __webpack_public_path__ + "img/安慕希.a885cf5f.jpg";